'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _classNames2 = require('react-utils/classNames');

var _classNames3 = _interopRequireDefault(_classNames2);

var _visibility = require('conversations-lib/visibility');

var visibility = _interopRequireWildcard(_visibility);

var _RequestStatusTypes = require('conversations-schema/constants/RequestStatusTypes');

var RequestStatusTypes = _interopRequireWildcard(_RequestStatusTypes);

var _PostMessageTypes = require('../constants/PostMessageTypes');

var _Reagan = require('../constants/Reagan');

var _AsyncPropTypeBanner = require('../code-splitting/components/AsyncPropTypeBanner');

var _AsyncPropTypeBanner2 = _interopRequireDefault(_AsyncPropTypeBanner);

var _buildWidgetData = require('../widget-data/operators/buildWidgetData');

var _ApplicationLayout = require('./ApplicationLayout');

var _ApplicationLayout2 = _interopRequireDefault(_ApplicationLayout);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Application = function (_React$Component) {
  _inherits(Application, _React$Component);

  function Application(props) {
    _classCallCheck(this, Application);

    var _this = _possibleConstructorReturn(this, (Application.__proto__ || Object.getPrototypeOf(Application)).call(this, props));

    _this.handleDragover = _this.handleDragover.bind(_this);
    _this.handleDrop = _this.handleDrop.bind(_this);
    _this.registerDragDropHandlers = _this.registerDragDropHandlers.bind(_this);
    _this.unregisterDragDropHandlers = _this.unregisterDragDropHandlers.bind(_this);
    _this.isLoading = _this.isLoading.bind(_this);
    _this.hasApiError = _this.hasApiError.bind(_this);
    _this.handleVisibilityChange = _this.handleVisibilityChange.bind(_this);
    _this.registerContainerRef = _this.registerContainerRef.bind(_this);
    _this.getIframeDimensions = _this.getIframeDimensions.bind(_this);
    _this.onIframeResize = _this.onIframeResize.bind(_this);
    _this.onOpenUpdate = _this.onOpenUpdate.bind(_this);
    _this.requestWidget = _this.requestWidget.bind(_this);
    _this.onBrowserWindowResize = _this.onBrowserWindowResize.bind(_this);
    _this.receiveMessage = _this.receiveMessage.bind(_this);
    _this.renderContent = _this.renderContent.bind(_this);

    _this.state = {
      // initially assume the browser is big enough to fit the whole widget
      // then shrink as needed after first paint
      browserWindowHeight: 1080
    };
    return _this;
  }

  _createClass(Application, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.requestWidget();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('message', this.receiveMessage, false);
      this.registerDragDropHandlers();
      this.onIframeResize();

      if (visibility.isHidden()) {
        this.props.setWindowVisible(false);
      }

      visibility.addVisibilityChangeListener(this.handleVisibilityChange);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.receiveMessage);
      this.unregisterDragDropHandlers();

      visibility.removeVisibilityChangeListener(this.handleVisibilityChange);
    }
  }, {
    key: 'handleDragover',
    value: function handleDragover(event) {
      event.preventDefault();
    }
  }, {
    key: 'handleDrop',
    value: function handleDrop(event) {
      event.preventDefault();
    }
  }, {
    key: 'registerDragDropHandlers',
    value: function registerDragDropHandlers() {
      window.addEventListener('dragover', this.handleDragover);
      window.addEventListener('drop', this.handleDrop);
    }
  }, {
    key: 'unregisterDragDropHandlers',
    value: function unregisterDragDropHandlers() {
      window.removeEventListener('dragover', this.handleDragover);
      window.removeEventListener('drop', this.handleDrop);
    }
  }, {
    key: 'isLoading',
    value: function isLoading() {
      var loadingStatuses = (0, _immutable.List)([RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.PENDING]);

      return loadingStatuses.includes(this.props.widgetDataStatus);
    }
  }, {
    key: 'hasApiError',
    value: function hasApiError() {
      return this.props.widgetDataStatus === RequestStatusTypes.FAILED;
    }
  }, {
    key: 'handleVisibilityChange',
    value: function handleVisibilityChange(_ref) {
      var isVisible = _ref.isVisible;

      this.props.setWindowVisible(isVisible);
    }
  }, {
    key: 'registerContainerRef',
    value: function registerContainerRef(element) {
      this.containerRef = element ? (0, _reactDom.findDOMNode)(element) : null;
    }
  }, {
    key: 'getIframeDimensions',
    value: function getIframeDimensions() {
      var dimensions = this.containerRef ? this.containerRef.getBoundingClientRect() : {};
      var width = dimensions.width,
          height = dimensions.height;


      return {
        width: width,
        height: height
      };
    }
  }, {
    key: 'onIframeResize',
    value: function onIframeResize(size) {
      this.props.handleIframeResize(size || this.getIframeDimensions());
    }
  }, {
    key: 'onOpenUpdate',
    value: function onOpenUpdate(isOpened) {
      this.props.toggleOpen(isOpened);
    }
  }, {
    key: 'requestWidget',
    value: function requestWidget() {
      this.props.handleRequestWidget();
    }
  }, {
    key: 'onBrowserWindowResize',
    value: function onBrowserWindowResize(data) {
      this.setState({
        browserWindowHeight: data.height,
        browserWindowWidth: data.width
      });
    }
  }, {
    key: 'receiveMessage',
    value: function receiveMessage(_ref2) {
      var rawData = _ref2.data;

      var parsedData = null;
      try {
        parsedData = JSON.parse(rawData);
      } catch (err) {
        // unparseable / unexpected message format
        return;
      }

      var _parsedData = parsedData,
          _parsedData$type = _parsedData.type,
          type = _parsedData$type === undefined ? null : _parsedData$type,
          _parsedData$data = _parsedData.data,
          data = _parsedData$data === undefined ? null : _parsedData$data;


      switch (type) {
        case _PostMessageTypes.WIDGET_DATA:
          this.props.widgetDataReceived({ data: data, parsedData: parsedData, rawData: rawData });
          break;
        case _PostMessageTypes.REFRESH_WIDGET_DATA:
          {
            this.props.refreshWidgetData((0, _buildWidgetData.buildWidgetData)(parsedData.data));
            break;
          }
        case _PostMessageTypes.REQUEST_OPEN:
          this.onOpenUpdate(true);
          break;
        case _PostMessageTypes.REQUEST_CLOSE:
          this.onOpenUpdate(false);
          break;
        case _PostMessageTypes.BROWSER_WINDOW_RESIZE:
          this.onBrowserWindowResize(data);
          break;
        default:
          break;
      }
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      return _react2.default.createElement(_ApplicationLayout2.default, {
        browserWindowHeight: this.state.browserWindowHeight,
        browserWindowWidth: this.state.browserWindowWidth,
        handleClosedWelcomeMessage: this.props.handleClosedWelcomeMessage,
        inline: this.props.inline,
        isOpen: this.props.isOpen,
        mobile: this.props.mobile,
        onIframeResize: this.onIframeResize,
        toggleOpen: this.props.toggleOpen
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var shouldRenderContent = !this.isLoading() && !this.hasApiError();

      var classes = (0, _classNames3.default)('widget-app-container', (_classNames = {}, _defineProperty(_classNames, _Reagan.CLASSES.VISITOR_SUCCESS, shouldRenderContent), _defineProperty(_classNames, _Reagan.CLASSES.VISITOR_ERROR, this.hasApiError()), _classNames));

      return _react2.default.createElement(
        'div',
        { ref: this.registerContainerRef, className: classes },
        shouldRenderContent ? this.renderContent() : null,
        _react2.default.createElement(_AsyncPropTypeBanner2.default, null)
      );
    }
  }]);

  return Application;
}(_react2.default.Component);

Application.propTypes = {
  handleClosedWelcomeMessage: _react.PropTypes.func.isRequired,
  handleIframeResize: _react.PropTypes.func.isRequired,
  handleRequestWidget: _react.PropTypes.func.isRequired,
  inline: _react.PropTypes.bool.isRequired,
  isOpen: _react.PropTypes.bool.isRequired,
  mobile: _react.PropTypes.bool.isRequired,
  refreshWidgetData: _react.PropTypes.func.isRequired,
  setWindowVisible: _react.PropTypes.func.isRequired,
  toggleOpen: _react.PropTypes.func.isRequired,
  widgetDataReceived: _react.PropTypes.func.isRequired,
  widgetDataStatus: _react.PropTypes.oneOf(Object.keys(RequestStatusTypes)).isRequired
};

exports.default = Application;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/Application.js
// module id = 933
// module chunks = 2 3